export default "__VITE_ASSET__b0G5Sv9W__"